import React, { memo } from 'react';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';

export const Restore = memo<{ onClick: () => void }>(({ onClick }) => {
    return (
        <div>
            <Hint text="Восстановить">
                <div>
                    <DataListControl type="restore" onClick={onClick} />
                </div>
            </Hint>
        </div>
    );
});

Restore.displayName = 'Restore';
